export const TEST_ID = 'withDataHeader';

export const CONTENT_TEST_ID = 'withDataHeaderContent';
